import DataTableCellM from "@common/components/dataTable/DataTableCellM"
import DataTableTitleM from "@common/components/dataTable/DataTableTitleM"
import { PaginatedFlatList } from "@common/screens/PaginatedFlatList"
import { theme } from "@common/theme/theme"
import React from "react"
import { Dimensions, View } from "react-native"
import { Divider } from "react-native-paper"

export function PaginatedTableM({
    data,
    flatListRef = null,
    columns,
    headerHeight,
    requestService,
    urlParams,
    routeParams,
    noHeader = false,
    expandedRow,
    expandedRowContent,
    additionalHeader = <></>,
    style = {},
    noRefreshWhenNoResults = false,
}) {
    return (
        <PaginatedFlatList
            noRefreshWhenNoResults={noRefreshWhenNoResults}
            data={data}
            ref={flatListRef}
            style={{
                width: "100%",
                backgroundColor: theme.colors.white,
                flex: 1,
                ...style,
            }}
            contentContainerStyle={{
                alignItems: "flex-start",
                width: "100%",
            }}
            additionalOnRefresh={() => {}}
            requestApiService={requestService}
            requestRouteParams={routeParams}
            requestUrlParams={urlParams}
            requestData={null}
            tooManyColumns={true}
            stickyHeader={true}
            ListHeaderComponent={
                !noHeader && (
                    <>
                        {additionalHeader}
                        <View
                            style={{
                                height: headerHeight,
                                backgroundColor: theme.colors.primaryLighter,
                                flexDirection: "row",
                                justifyContent: "flex-start",
                                minWidth: Dimensions.get("window").width,
                                position: "sticky",
                                top: 0,
                            }}
                        >
                            {columns.map((column, index) => (
                                <DataTableTitleM
                                    key={index}
                                    style={column.style}
                                    sortingColumn={column}
                                    dataToSort={data}
                                    setDataToSort={data}
                                    sortDirection={
                                        column.sortable ? "ascending" : null
                                    }
                                    fontSize={12}
                                    fontWeight={"Bold"}
                                >
                                    {column.name}
                                </DataTableTitleM>
                            ))}
                        </View>
                    </>
                )
            }
            renderItem={(row) => {
                const item = row?.item ?? null
                const index = row.index

                const isExpanded = expandedRow === item.id

                return (
                    <View>
                        <View
                            style={{
                                flexDirection: "row",
                                justifyContent: "flex-start",
                                minWidth: Dimensions.get("window").width,
                            }}
                        >
                            {columns.map((col, colIndex) => (
                                <DataTableCellM
                                    key={colIndex}
                                    style={col.style}
                                    textStyle={{
                                        width: col?.style?.maxWidth,
                                    }}
                                >
                                    {col.cell(item, index)}
                                </DataTableCellM>
                            ))}
                        </View>
                        {isExpanded && expandedRowContent(item)}
                        <Divider />
                    </View>
                )
            }}
        />
    )
}
